import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const MagnifierMinimize = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M6.47 8.574h5.85a.84.84 0 0 1 .836.838.84.84 0 0 1-.836.837H6.47a.84.84 0 0 1-.836-.837.84.84 0 0 1 .835-.838Z" }), _jsx("path", { fillRule: "evenodd", d: "m15.797 14.433 2.173 2.177a1.258 1.258 0 0 1-.886 2.144 1.24 1.24 0 0 1-.886-.368l-2.223-2.228a8.1 8.1 0 0 1-4.58 1.415c-4.493 0-8.145-3.66-8.145-8.161 0-4.502 3.652-8.162 8.145-8.162s8.144 3.66 8.14 8.162a8.1 8.1 0 0 1-1.738 5.02ZM9.395 3.763c-3.11 0-5.638 2.533-5.638 5.649s2.529 5.649 5.638 5.649 5.637-2.534 5.637-5.65c0-3.115-2.528-5.648-5.637-5.648" })] }));
});
MagnifierMinimize.displayName = 'MagnifierMinimize';
MagnifierMinimize.__iconComponentType = 'standard';
export default MagnifierMinimize;
//# sourceMappingURL=MagnifierMinimize.js.map